var map = {
	"./404.svg": 1717,
	"./bug.svg": 1718,
	"./chart.svg": 1719,
	"./clipboard.svg": 1720,
	"./component.svg": 1721,
	"./dashboard.svg": 1722,
	"./documentation.svg": 1723,
	"./drag.svg": 1724,
	"./edit.svg": 1725,
	"./education.svg": 1726,
	"./email.svg": 1727,
	"./example.svg": 1728,
	"./excel.svg": 1729,
	"./exit-fullscreen.svg": 1730,
	"./eye-open.svg": 1731,
	"./eye.svg": 1732,
	"./form.svg": 1733,
	"./fullscreen.svg": 1734,
	"./guide.svg": 1735,
	"./icon.svg": 1736,
	"./international.svg": 1737,
	"./language.svg": 1738,
	"./link.svg": 1739,
	"./list.svg": 1740,
	"./lock.svg": 1741,
	"./message.svg": 1742,
	"./money.svg": 1743,
	"./nested.svg": 1744,
	"./password.svg": 1745,
	"./pdf.svg": 1746,
	"./people.svg": 1747,
	"./peoples.svg": 1748,
	"./qq.svg": 1749,
	"./search.svg": 1750,
	"./shopping.svg": 1751,
	"./size.svg": 1752,
	"./skill.svg": 1753,
	"./star.svg": 1754,
	"./tab.svg": 1755,
	"./table.svg": 1756,
	"./theme.svg": 1757,
	"./tree-table.svg": 1758,
	"./tree.svg": 1759,
	"./user.svg": 1760,
	"./wechat.svg": 1761,
	"./zip.svg": 1762
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2188;


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 2188
// module chunks = 1